import { useMemo } from 'react'

import { EMPTY_OBJECT } from '../../../../constants/common'
import { updateSignature } from '../../../../utils/signature'
import { getEmailCreationFormInitialAccount } from '../../Email.utils'
import {
  EMAIL_CREATION_FORM_FIELD_NAME_FROM,
  EMAIL_CREATION_FORM_FIELD_NAME_MESSAGE,
  EMAIL_CREATION_FORM_FIELD_NAME_SIGNATURE,
  EMAIL_CREATION_FORM_INITIAL_VALUES,
} from '../../EmailCreationForm'

export function useEmailCreationFormInitialValues({
  account,
  initialValues = EMAIL_CREATION_FORM_INITIAL_VALUES,
} = EMPTY_OBJECT) {
  // updateSignature reads account.value as the account ID. Raw accounts from
  // context have id but no value, so we convert first to avoid removeSignature
  // being called on a message that already contains a valid signature.
  const formAccount = getEmailCreationFormInitialAccount(account)

  const [message, signatureHTML] = updateSignature(
    initialValues[EMAIL_CREATION_FORM_FIELD_NAME_MESSAGE],
    formAccount
  )

  return useMemo(
    () => ({
      ...initialValues,
      [EMAIL_CREATION_FORM_FIELD_NAME_FROM]:
        getEmailCreationFormInitialAccount(account),
      [EMAIL_CREATION_FORM_FIELD_NAME_MESSAGE]: message,
      [EMAIL_CREATION_FORM_FIELD_NAME_SIGNATURE]: signatureHTML,
    }),
    [account, initialValues, message, signatureHTML]
  )
}
